'use client'

import { useState } from "react"
import Avatar from "boring-avatars"

import { cn, formatImageURL } from "@/lib/util"

interface UserAvatarProps {
  // The stored file name or address; a `blob:` address shows a picture that is still uploading.
  avatar?: string | null
  // What the face is drawn from when there is no picture. The same seed gives the same face.
  seed: string
  size: number
  className?: string
}

// A person's picture, or a generated face until they have one.
export default function UserAvatar({ avatar, seed, size, className }: UserAvatarProps) {
  // The address that failed to load, so a new picture gets its own try.
  const [broken, setBroken] = useState<string | null>(null)
  const source = avatar && avatar !== broken ? (avatar.startsWith('blob:') ? avatar : formatImageURL(avatar)) : null

  return (
    <div className={cn("shrink-0 overflow-hidden rounded-full bg-muted", className)} style={{ width: size, height: size }}>
      {source ? (
        // A picture that came with a Google sign-in is served only without a referrer.
        // eslint-disable-next-line @next/next/no-img-element
        <img src={source} alt="" referrerPolicy="no-referrer" className="size-full object-cover" onError={() => setBroken(avatar || null)} />
      ) : (
        // A dropdown item shrinks any svg inside it to 16px unless the svg carries a size class.
        <Avatar size={size} name={seed} variant="beam" className="size-full" />
      )}
    </div>
  )
}
